<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'EventsHeader',
  inject: ['wp']
}
</script>
